import React, { useEffect, useRef, useState } from "react";
import { Link, useParams } from "react-router-dom";
import imgosatya from "../../../assets/images/invitation_images/PC/birthday/3.png";
import { loadEventImages } from "../invitationpageid";
import RSVPCard from "./RSVPCard"
import { getinvitation_templates_by_category } from "../../../Apiservices/Auth/servers/fetchinvitationtemplates";
import {
  fetchRSVPDetails,
  submitRSVPResponse,
} from "../../../services/RSVPServices";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { Toast } from "primereact/toast";
import "./RSVPInvitationPage_pooja.css";
import formatDate from "../../../util/FormateDate";
import thurentlogo from "../../../redesign/assets/thurent-logo.svg"

export const RSVPInvitationPage_pooja = ({EventDataForInvitation,imageUrl_as_prop}) => {
  const { sharedToken } = useParams();
  console.log("setEventDataForInvitation",EventDataForInvitation,imageUrl_as_prop)
  const [eventDetails, setEventDetails] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [submittedResponse, setSubmittedResponse] = useState(null);
  const toast = useRef(null);
  const [imageloading, setimageloading] = useState(true)
    const [fetchedimage,setfetchedimage ]= useState(null)
  const [imageUrl, setImageUrl] = useState(null);
const [screenname, setscreenname] = useState("")
  // Utility function to show success toast
  const showSuccess = (details) => {
    toast.current.show({
      severity: "success",
      summary: "Response Submitted",
      detail: details,
      life: 3000,
    });
  };

  // Utility function to show error toast
  const showError = (detail) => {
    toast.current.show({
      severity: "error",
      summary: "Submission Failed",
      detail: detail,
      life: 3000,
    });
  };
const styleConfig = {
  cardBackground: "#f9f9f9",
  headingColor: "#000000ff",
  headingFontSize: "24px",
  textColor: "#333",
  padding: "20px",
  venueFontSize: "16px",
};

const eventDataforstyles = {
  ...eventDetails, // take all event fields
  styleConfig,               // add/override styleConfig separately
};

  useEffect(() => {
    if (imageUrl_as_prop) {
      // reset first to force rerender (prevents black flash)
      setImageUrl(null);
      // then set again in next tick
      const timeout = setTimeout(() => {
        setImageUrl(imageUrl_as_prop);
      }, 0);

      return () => clearTimeout(timeout);
    }
  }, [imageUrl_as_prop]);
useEffect(() => {
  if (EventDataForInvitation) {
    setEventDetails(EventDataForInvitation);

    if (imageUrl_as_prop) {
      // Case 1: both data and image URL provided
      setImageUrl(imageUrl_as_prop);
      setimageloading(false);
      setLoading(false);
      console.log("Using provided data and image");
      return; // skip fetching
    } else {
      // Case 2: data provided but no image
      setImageUrl(null);
      setimageloading(false);
      setLoading(false);
      console.log("Using provided data, no image");
      return; // skip fetching
    }
  }

  // Case 3: no EventDataForInvitation, check saved RSVP or fetch
  const savedResponse = localStorage.getItem(`rsvp_${sharedToken}`);
  try {
    if (savedResponse) {
      console.log("savedResponse => ", savedResponse);
      setSubmittedResponse(JSON.parse(savedResponse));
    } else {
      fetchEventDetails();
    }
  } catch (error) {
    console.error("Error parsing savedResponse", error);
  } finally {
    setLoading(false);
    setimageloading(false); // make sure loading state is unset
  }
}, [sharedToken, EventDataForInvitation, imageUrl_as_prop]);



  const fetchEventDetails = async () => {
    try {
      const data = await fetchRSVPDetails(sharedToken);
      console.log("sharedtoken",data)
      if (data.message === "Event not found or invalid token") {
        setError("Sorry, no active event found");
      } else {
        setEventDetails(data);
           if (!imageUrl) {
        await getimage(data);
      }
      }
    } catch (err) {
      setError("Sorry, no active event found");
    }
        window.scrollTo({
  top: window.innerHeight / 2,
  behavior: 'smooth'
});
  };

  // console.log("eventDetails", eventDetails);

  const RSVPValidationSchema = Yup.object().shape({
    name: Yup.string().required("Name is required"),
    mobile: Yup.string()
      .matches(/^[6-9]\d{9}$/, "Enter a valid mobile number")
      .required("Mobile number is required"),
    attendance: Yup.string().required("Please select your attendance"),
    members: Yup.number()
      .min(1, "Must be at least 1 member")
      .max(10, "Max people allowed is 25. If more than 25 are attending, please call the host and let them know.")
      .required("Number of members is required"),
  });

// Function to get image based on event details
// Function to get image based on event details
// const getimage = async (eventDetails) => {
//   if (!eventDetails?.EventMasterDetails) return;

//   const category = encodeURIComponent(eventDetails.EventMasterDetails.eventCategoryName);
//   const title = encodeURIComponent(eventDetails.EventMasterDetails.eventName.replace(/\s+/g, ""));
//   const screenType = window.innerWidth > 800 ? "web" : "mobile";
//   const imageName = eventDetails.imagePath;

//   const image_path_url = `/templates-bg/${category}/${title}/${screenType}/${imageName}`;
//   const fallbackUrl = "/templates-bg/Birthday/1stFirstBirthday/web/1.png";

//   try {
//     let blob = await getinvitation_templates_by_category(image_path_url);
    
//     if (blob) {
//       setfetchedimage(blob); // Set the Blob directly
//       return;
//     }

//     console.warn("First attempt failed, trying fallback:", fallbackUrl);
//     blob = await getinvitation_templates_by_category(fallbackUrl);

//     if (blob) {
//       setfetchedimage(blob); // Set the Blob directly
//       return;
//     }

//     console.error("Both fetches failed, using static fallback URL");
//     setfetchedimage(null); // Optionally set to null or handle fallback differently

//   } catch (error) {
//     console.error("Unexpected error in getimage:", error);
//     setfetchedimage(null); // Optionally set to null or handle fallback differently
//   } finally {
//     setimageloading(false);
//   }
// };





const getimage = async (eventDetails) => {
  if (!eventDetails?.EventMasterDetails) return;
  console.log("eventdatatesting",eventDetails)
  const category = encodeURIComponent(eventDetails.EventMasterDetails.eventCategoryName);
  const title = encodeURIComponent(eventDetails.EventMasterDetails.eventName.replace(/\s+/g, ""));
  const screenType = window.innerWidth > 800 ? "web" : "mobile";
  const imageName = eventDetails.imagePath;
  const image_path_url = `/templates-bg/${category}/${title}/${screenType}/${imageName}`;

  try {
    const blob = await getinvitation_templates_by_category(image_path_url);
    setfetchedimage(blob || null);
  } catch (error) {
    console.error(error);
    setfetchedimage(null); // page won't crash, image just won't show
  } finally {
    setimageloading(false);
  }
};


  useEffect(() => {
    console.log("fetchedimage", fetchedimage);
    
    if (fetchedimage) {
      // Create an object URL from the fetched image Blob
      const blobUrl = URL.createObjectURL(fetchedimage);
      console.log("Got Image",blobUrl)
      setImageUrl(blobUrl);

      // Cleanup the object URL when the component unmounts or image changes
      return () => {
        URL.revokeObjectURL(blobUrl);
      };
    } else {
      // Reset imageUrl if fetchedimage is null
      setImageUrl(null);
    }
  }, [fetchedimage]);
  
  const handleSubmit = async (values, { setSubmitting, setErrors }) => {
    const isComing = values.attendance === "yes";
    console.log("values => ", values);
    const rsvpPayload = {
      name: values.name,
      phoneNumber: values.mobile,
      sharedToken: sharedToken,
      isComing: isComing,
      isReminderRequired: values.remind,
      //   extraMembers: values.members > 1 ? values.members - 1 : 0, // Correctly calculate extra members
      extraMembers: isComing ? values.members : 0, // Correctly calculate extra members
      remarks: values.suggestion,
    };
    console.log("rsvpPayload => ", rsvpPayload);

    try {
      const response = await submitRSVPResponse(rsvpPayload);
      console.log(response);
      if (response.status === 200 || response.status === 201) {
        const rsvpData = {
          ...response.data.rsvp,
          submitted: true,
          statusCode: response.status,
        };
        localStorage.setItem(`rsvp_${sharedToken}`, JSON.stringify(rsvpData));
        setSubmittedResponse(rsvpData);
        showSuccess(`Thank you for your response, ${rsvpData.name}!`);
      } else if (response.status === 409) {
        const conflictResponse = {
          submitted: true,
          statusCode: response.status,
        };
        localStorage.setItem(
          `rsvp_${sharedToken}`,
          JSON.stringify(conflictResponse)
        );
        setSubmittedResponse(conflictResponse);
        showError("Response already submitted .");
      }
    } catch (error) {
      console.error(error);
      showError("Something went wrong. Please try again later.");
    } finally {
      setSubmitting(false);
    }
  };
console.log("imageloading",imageUrl)
  if (loading) {
    return (
      <>
        <Toast ref={toast} />
        <div>Loading...</div>;
      </>
    );
  }

  //   if (error) {
  //     return <div>{error}</div>;
  //   }
  
// if (imageloading) {
//   return submittedResponse ? (
//     <div
//       style={{
//         height: "100vh",
//         display: "flex",
//         justifyContent: "center",
//         alignItems: "center",
//         background: "white",
//       }}
//     >
//       <Toast ref={toast} />
//       <div className="thank-you-card">
//         <h2>
//           Thank you for your response
//           {submittedResponse.name ? `, ${submittedResponse.name}!` : "!"}
//         </h2>
//       </div>
//     </div>
//   ) : (
//     <div
//       style={{
//         width: "100%",
//         height: "100vh",
//         display: "flex",
//         justifyContent: "center",
//         alignItems: "center",
//         background: "white",
//       }}
//     >
//       <h3 style={{ textAlign: "center" }}>
//         <i
//           className="pi pi-spin pi-spinner-dotted"
//           style={{ fontSize: "2rem", color: "#0cc0df" }}
//         />
//       </h3>
//     </div>
//   );
// }
  if (submittedResponse) {
    return (
      <div
        style={{
          height: "100vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Toast ref={toast} />
        <div className="thank-you-card">
          <h2>
            Thank you for your response
            {submittedResponse && submittedResponse.name
              ? `, ${submittedResponse.name}!`
              : ""}
          </h2>
        </div>
      </div>
    );
  }

  if (!eventDetails || error) {
    return (
      <div
        style={{
          height: "100vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Toast ref={toast} />
        <div className="thank-you-card">
          <h2>{!eventDetails ? "No event details available" : error}</h2>
        </div>
      </div>
    );
  }

  const { eventType, invitedBy, venue, startDate } = eventDetails;
// console.log("eventDetails",eventDetails,eventType,invitedBy,venue,startDate)
  return (
    <div className="rsvp-invitation-container">
         {/* <img
         style={{width:"100%",height:"1%"}}          
          src={imgosatya}
        />  */}
        <div className="rsvp-wrapper">
            {imageUrl ? (
    <img src={imageUrl} alt="Invitation" className="rsvp-image" />
  ) : null}
          
          <div className="rsvp-content ">
            <div style={{marginTop:"90px"}}></div>
      <Toast ref={toast} />
     <RSVPCard
        eventType={eventDataforstyles.eventType}
        invitedBy={eventDataforstyles.invitedBy}
        startDate={eventDataforstyles.startDate}
        venue={eventDataforstyles.venue}
        styleConfig={eventDataforstyles.styleConfig}
        onSubmitForm={handleSubmit}
      />
      </div>
      {/* <img
        className="invpat invleft"
        src={`${process.env.PUBLIC_URL}/assets/images/invleft.png`}
      />
      <img
        className="invpat invleftb"
        src={`${process.env.PUBLIC_URL}/assets/images/invleftb.png`}
      />
      <img
        className="invpat invright"
        src={`${process.env.PUBLIC_URL}/assets/images/invright.png`}
      />
      <img
        className="invpat invrightb"
        src={`${process.env.PUBLIC_URL}/assets/images/invrightb.png`}
      /> */}
      </div>
    </div>
  );
};
